@if (archive) {
<div class="panel highlight">
	<div class="heading">Record new adjustment</div>
	<div class="content">
		<div class="row">
			<div class="col-lg-6">
				<p>Adjustments:</p>
				<table class="adjustments fat">
					@for (adjdef of rotor.adjdef; track adjdef; let i = $index) {
					<!-- Display heading for every "display group" -->
					@if (i === 0 || rotor.adjdef[i].displaygroup !== rotor.adjdef[i-1].displaygroup) {
					<tr>
						<th></th>
						@for (blade of FilterBlades(rotor.adjdef[i].displaygroup); track blade) {
						<th>{{blade.name}}</th>
						}
					</tr>
					}
					<tr>
						<th>{{adjdef.name}}</th>
						@for (blade of FilterBlades(rotor.adjdef[i].displaygroup); track blade; let j = $index) {
						<td>
							<input type="text" step="any" [(ngModel)]="archive.adjustments[i][j]">
						</td>
						}
					</tr>
					}
				</table>
				@if (archive.isClockwise) {
				<p class="mt-2">Note: blade is clockwise</p>
				}
			</div>
			<div class="col-lg-6">
				<p>Adjustment generated from operation: {{archive.operation_start | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</p>
				<div class="mb-3">
					<label>User note:</label>
					<div>
						<textarea [(ngModel)]="userNote" class="form-control" style="min-height: 150px;"></textarea>
					</div>
				</div>
				<app-action-button [action]="UploadAdjustment" [context]="this" processing="Saving..." complete="Adjustment recorded" btnClass="green">Record adjustment</app-action-button>
				<button (click)="CancelAdjustment()" class="button ms-2">Cancel</button>
			</div>
		</div>
	</div>
</div>
}
<div class="row">
	<div class="col-lg-4">
		<div class="panel constrain">
			<div class="heading">Regimes</div>
			<div class="content nopad">
				<table class="log openborders paneled regimes">
					<thead>
						<tr>
							<th># Acq</th>
							<th>Regime</th>
							<th>Evaluate</th>
						</tr>
					</thead>
					@for (regime of regimeCounts ?? []; track regime) {
					<tbody>
						<tr>
							<td>{{regime.count}}</td>
							<td>{{regime.name}}</td>
							<td class="center">
								<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
							</td>
						</tr>
					</tbody>
					}
					@if (regimeCounts === undefined) {
					<tbody>
						<tr>
							<td colspan="3" class="loading-status">
								<div class="logo-spin"></div>
								Loading regimes...
							</td>
						</tr>
					</tbody>
					}
					@if (regimeCounts?.length === 0) {
					<tbody>
						<tr>
							<td colspan="3" class="loading-status">No regime data found</td>
						</tr>
					</tbody>
					}
				</table>
			</div>
		</div>
		@if (regimeCounts && regimeCounts.length && rotor.balancedata && rotor.balancedata.numblades >= 4) {
		<div class="row">
			<div class="col-4">
				Shaft Order
			</div>
			<div class="col-8">
				<div class="form-check form-check-inline">
					<label>
						<input [(ngModel)]="shaftOrder" name="shaftorder" type="radio" [value]="1" (ngModelChange)="loadRegimes()">
						1/rev
					</label>
				</div>
				<div class="form-check form-check-inline">
					<label>
						<input [(ngModel)]="shaftOrder" name="shaftorder" type="radio" [value]="2" (ngModelChange)="loadRegimes()">
						2/rev
					</label>
				</div>
			</div>
		</div>
		}
		@if (regimeCounts && regimeCounts.length) {
		<div class="row">
			<div class="col-4">
				Sensor
			</div>
			<div class="col-8">
				@for (vshaft of vshafts; track vshaft) {
				<div class="form-check">
					<label>
						<input [(ngModel)]="selectedVShaft" name="vshaft" type="radio" [value]="vshaft" (ngModelChange)="loadRegimes()">
						{{vshaft.name}} ({{vshaft.shftid}})
					</label>
				</div>
				}
			</div>
		</div>
		}
	</div><!-- End left column -->
	<div class="col-lg-8">
		<div class="panel">
			<div class="heading">Averages (polar)</div>
			<div class="content">
				<app-dvs-chart #polarChart [options]="polarOptions" loading="Loading vibration data" [error]="errormessage" [height]="'600px'"
					[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
			</div>
		</div>
	</div>
</div>
<div class="panel">
	<div class="heading">Averages (timeline)</div>
	<div class="content">
		<app-dvs-chart #timelineChart [options]="timelineOptions" loading="Loading vibration data" [error]="errormessage" [height]="'200px'"
			[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
		@if (timelineOptions && adjustments && adjustments.length) {
		<div class="chart-legend">
			<span class="legend-item">
				<span class="swatch adjustment"></span> Adjustment (see below)
			</span>
		</div>
		}
	</div>
</div>
<div class="panel">
	<div class="heading">Adjustment History</div>
	<div class="content nopad">
		@if (adjustments && !adjustments.length) {
		<div class="p-3">
			No adjustments have been recorded for this rotor
		</div>
		}
		@if (adjustments && adjustments.length) {
		<div>
			<div class="p-3">Rotor blades: {{blades}}</div>
			<table class="log openborders paneled adjustment-history">
				<thead>
					<tr>
						<th>Operation</th>
						<th>Entered by</th>
						@for (adjdef of rotor.adjdef; track adjdef) {
						<th>{{adjdef.name}}</th>
						}
						<th>User note</th>
						@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<th>
							Delete</th>
						}
					</tr>
				</thead>
				@for (adjustment of adjustments; track adjustment) {
				<tbody>
					<tr>
						<td>{{adjustment.operation_start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
						<td>{{adjustment.author_email}}</td>
						@for (row of adjustment.adjustments.split('|'); track row) {
						<td>{{row | commalist}}</td>
						}
						<td [title]="adjustment.user_note"><span>{{adjustment.user_note}}</span></td>
						@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<td>
							<app-action-button [action]="DeleteAdjustment" [args]="[adjustment.adjustment_history_id]" [context]="this" btnClass="icon red" confirm="Are you sure?"
								processing="..."><i class="icon-trash"></i></app-action-button>
						</td>
						}
					</tr>
				</tbody>
				}
			</table>
		</div>
		}
	</div>
</div>